'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commentMessageToPubNubMessage = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _getMappedCommentSenderType = require('./getMappedCommentSenderType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commentMessageToPubNubMessage = exports.commentMessageToPubNubMessage = function commentMessageToPubNubMessage(message) {
  var editedMessage = {
    id: (0, _getIn2.default)(['id'], message),
    metadata: message,
    senderId: (0, _getIn2.default)(['sender', 'id'], message),
    senderType: (0, _getMappedCommentSenderType.getMappedSenderTypeFromPubnubMessage)((0, _getIn2.default)(['sender', '@type'], message)),
    timestamp: (0, _getIn2.default)(['timestamp'], message),
    clientTs: (0, _getIn2.default)(['timestamp'], message),
    type: message['@type']
  };
  return editedMessage;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/commentMessageToPubNubMessage.js
// module id = 374
// module chunks = 2 3